import { Button } from './Button';
import { Heading } from './Heading';
import { Stack } from './Stack';
import { Text } from './Text';

/** Props for {@link ErrorState}. */
export interface ErrorStateProps {
  /** Short statement of what failed. */
  readonly title?: string;
  /** What went wrong, in terms the reader can act on. */
  readonly message: string;
  /** Invoked when the reader chooses to try again. */
  readonly onRetry?: () => void;
}

/**
 * Shown when a view failed to load.
 *
 * Always offers a retry when one is possible: most failures here are transient connectivity, which
 * is the normal condition at an event venue rather than an exceptional one.
 *
 * @param props - Component props.
 * @returns The error state element.
 */
export function ErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
}: ErrorStateProps): React.JSX.Element {
  return (
    <div className="gm-state" role="alert">
      <Stack gap="md" align="center">
        <Heading level={3}>{title}</Heading>
        <Text muted>{message}</Text>
        {onRetry !== undefined && (
          <Button variant="primary" onClick={onRetry}>
            Try again
          </Button>
        )}
      </Stack>
    </div>
  );
}
